import {
  GetUserAccessRulesResponseBody,
  RolePrivilegeInfo,
} from '@crossnokaye/typescript-sdk/models/components';

import { UserPrivilegeMap } from '../types';

/**
 * Given user roles and a privilege map,
 * determine the user's privileges, by scope.
 * Ported from Darkwing's mapUserPrivileges
 */
export function mapUserPrivileges(
  userAccessRules: GetUserAccessRulesResponseBody | undefined,
  rolePrivilegeInfo: RolePrivilegeInfo | undefined
): UserPrivilegeMap {
  const result = new Map<string, Set<string>>();

  const rules = userAccessRules?.accessRules || [];
  const roles = rolePrivilegeInfo?.roles || [];

  // Group privileges by role
  const roleMap: Record<string, string[]> = {};
  roles.forEach((role) => {
    if (role.name && role.privileges) {
      roleMap[role.name] = role.privileges;
    }
  });

  // Expand the user roles for each scope
  rules.forEach((rule) => {
    if (!rule.scope) return;

    const scope = parseScope(rule.scope);

    // Store the privileges for each individual scope
    [scope.org, scope.facility, scope.agent].forEach((id) => {
      if (!id) return;

      let privileges = result.get(id);
      if (!privileges) {
        privileges = new Set<string>();
        result.set(id, privileges);
      }

      if (rule.roles) {
        for (const role of rule.roles) {
          for (const entry of roleMap[role] || []) {
            privileges.add(entry);
          }
        }
      }
    });
  });

  return result;
}

// Given a scope string of the form:
// '/orgs/orgId/facilities/facId/agents/agentId'
// parse it into an object
function parseScope(scope: string) {
  const result = {
    org: '',
    facility: '',
    agent: '',
  };

  const parts = (scope || '').split('/').filter((s) => s);
  let next = parts.shift();

  while (next) {
    switch (next) {
      case 'orgs':
        result.org = parts.shift() || '';
        break;
      case 'facilities':
        result.facility = parts.shift() || '';
        break;
      case 'agents':
        result.agent = parts.shift() || '';
        break;
    }
    next = parts.shift();
  }

  return result;
}
